import axios from 'axios';
import {getAuthExternal} from 'context/AuthContext';
import {refreshCsrfOnce} from './fetchCsrfToken';
import Token from './Token';
import {XCSRF_TOKEN_HEADER} from 'const';
import {getAxiosErrorMessage} from './getAxiosErrorMessage';

axios.interceptors.response.use(
   (response) => {
      console.debug('intercept', response);
      return response;
   },
   async (e) => {
      const error = {
         ...e,
         _message: e.message,
         message: getAxiosErrorMessage(e) || e.message,
      };
      console.debug('intercept error', error);
      const originalRequest = error.config;

      if (error.response?.status === 401) {
         console.debug('Intercept error 401 > logout', getAuthExternal());
         getAuthExternal().logout();
         return Promise.reject(error);
      }

      // console.debug('axios error csrf', error.response.headers[XCSRF_TOKEN_HEADER.toLowerCase()]);
      if (
         error.response?.status === 403 &&
         !originalRequest._retry &&
         error.response.headers[XCSRF_TOKEN_HEADER.toLowerCase()] === 'Required'
         // String(error.response?.data?.message).toUpperCase().includes('CSRF')
      ) {
         originalRequest._retry = true;

         await refreshCsrfOnce();

         // update header
         originalRequest.headers['X-CSRF-Token'] = Token.getCsrfToken();
         return axios(originalRequest);
      }

      return Promise.reject(error);
   }
);

export const handleApiError = (res: Response) => {
   // console.debug('handleError', res.ok, res);
   if (!res.ok) {
      if (process.env.REACT_APP_DEBUG) {
         console.error('api error', res);
      }

      if (res.status === 401) {
         console.log('Unauthorized');
         getAuthExternal().logout();
         //   logout();
         //   login();
      }

      throw res;
   }
   return res;
};
